export default __webpack_public_path__ + "static/media/about-us-section-seven.a2b358b7.png";